import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Tooltip } from "@material-ui/core";
import { RiErrorWarningFill } from "react-icons/ri";
import UserProfile from "../../../app/partials/layout/UserProfile";

class Topbar extends React.Component {
    render() {
        const { agentMessageLimitReached, isAdmin, history } = this.props;

        return (
            <div className="kt-header__topbar gap-16">
                {agentMessageLimitReached && (
                    <Tooltip title={`Limite de mensagens enviadas para agentes atingido! ${isAdmin ? "Clique para gerenciar o plano" : "Contate o administrador"}`} placement="bottom" PopperProps={{ style: { marginTop: 4 } }}>
                        <div className="d-flex align-items-center" style={{ cursor: isAdmin ? "pointer" : "default" }} onClick={() => isAdmin && history.push("/financeiro")}>
                            <RiErrorWarningFill size={22} color="#F59E0B" />
                        </div>
                    </Tooltip>
                )}

                <UserProfile showAvatar={true} showHi={true} showBadge={false} />
            </div>
        );
    }
}

const mapStateToProps = (store) => ({
    agentMessageLimitReached: store.consumption?.agentMessageLimitReached,
    isAdmin: store.auth?.user?.usr_is_admin,
});

export default withRouter(connect(mapStateToProps)(Topbar));
